<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Customer Contact Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`New ${customer.full_name} Contact`" class="mb-3">
      <template #right-content>
        <b-button-toolbar key-nav aria-label="Key Customer Contact Actions">
          <b-button
            :to="`/customer/${customer_id}`"
            variant="success"
            class="ml-1 text-white"
          >
            <i class="fal fa-arrow-left" />
          </b-button>
        </b-button-toolbar>
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add customer contact'">
      <template #gated-content>
        <customer-contact-form @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import CustomerContactForm from "@/components/crm/customercontact/form/CustomerContactForm";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { CrmRepositoryFactory } from "@/repositories/crm/CrmRepositoryFactory";
import { customerContactNotifications } from "@/shared/notifications";
import { getModel } from "@/shared/fetch-utils";
import { notificationOptions } from "@/shared/toast-notification-options";

const CustomerContactsRepository = CrmRepositoryFactory.get("customerContacts");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "CustomerContactAdd",
  mixins: [ToastNotifications],
  components: {
    BasicHeading,
    CustomerContactForm,
    PermissionAlertGate,
  },
  data() {
    return {
      loading: true,
      customer_id: this.$route.params.customer_id || null,
      customer: null,
    };
  },
  methods: {
    async submit(form_data) {
      try {
        await CustomerContactsRepository.create({
          customer_id: this.customer_id,
          ...form_data,
        });

        this.addSuccess();
        this.$router.push(`/customer/${this.customer_id}`);
      } catch ({ response }) {
        const { status, data } = response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    },
  },
  async created() {
    this.loading = true;

    this.customer = await getModel({
      model_type: "customer",
      id: this.customer_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: customerContactNotifications,
};
</script>
